<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-open-account`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v36a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h36zm-2 4H8v32h32V8zm-15.962 3a8.485 8.485 0 016.038 14.446c4.208 1.246 7.424 5.21 7.424 9.908V36a1 1 0 01-1 1h-2.058a1 1 0 01-.996-.91 5.987 5.987 0 00-.027-.248c-.516-3.853-3.425-6.804-6.596-6.804h-5.668c-3.192 0-6.1 2.991-6.585 6.881a5.68 5.68 0 00-.018.173 1 1 0 01-.996.908H11.5a1 1 0 01-1-1v-.646c0-4.715 3.25-8.691 7.486-9.922A8.485 8.485 0 0124.038 11zm0 4a4.485 4.485 0 100 8.97 4.485 4.485 0 000-8.97z"/></svg>
</template>
<script>

export default {
  name: 'IconOpenAccount',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
